export const SAY_HELLO = "SAY_HELLO";
export const sayHelloAction = () => ({ type: SAY_HELLO });

export const SAY_BYE = "SAY_BYE";
export const sayByeAction = () => ({ type: SAY_BYE });
